import axiosInstance from "./api_helper";

const API_URL = '/api/commercials';

export const commercialService = {

  create: async (dto) => {
    const response = await axiosInstance.post(API_URL, dto);
    return response;
  },

  update: async (dto) => {
    const response = await axiosInstance.put(`${API_URL}/${dto.id}`, dto);
    return response;
  },

  get: async (id) => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  delete: async ({ id }) => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  list: async ({ query }) => {
    const params = {};
    if (query) params.query = query;
    const response = await axiosInstance.get(API_URL, { params });
    return response;
  },

  previewCommission: async ({ commercialId, period, refDate, startDate, endDate }) => {
    const params = { commercialId, period, refDate };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get(`/api/commissions/period/preview`, {
      params
    });
    return response;
  },

  postCommission: async ({ commercialId, period, refDate, ref, startDate, endDate }) => {
    const params = { commercialId, period, refDate, ref };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.post(`/api/commissions/period/post`, null, {
      params
    });
    return response;
  },

  loadPerformance: ({ startDate, endDate, baseRate }) => {
    const params = { startDate, endDate };
    if (baseRate !== undefined && baseRate !== null) params.baseRate = baseRate;
    return axiosInstance.get("/api/commissions/period/performance", { params });
  },

  listLedger: ({ commercialId, start, end }) =>
    axiosInstance.get("/api/commissions/ledger", { params: { commercialId, start, end } }),
  listLedgerEffective: ({ commercialId, start, end }) =>
    axiosInstance.get("/api/commissions/ledger/effective", { params: { commercialId, start, end } }),

  exportLedger: ({ commercialId, start, end, period, status }) =>
    axiosInstance.get("/api/commissions/ledger/export", {
      params: { commercialId, start, end, period, status },
      responseType: "blob", // ⬅️ important for CSV
    }),

  reverseCommission: ({ commercialId, period, refDate, ref }) =>
    axiosInstance.post("/api/commissions/period/reverse", null, {
      params: { commercialId, period, refDate, ref },
    }),

};
